import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DhlRadioButton } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";
import { breakpoints, grid } from "root/libs/ui-styleguide/src";
import ModalUnitSwitchInfo from "one-time-shipment/src/components/Modals/ModalUnitSwitchInfo";
import { UnitSelectorWrapper } from "./styled";

const GridSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, 90px);
  justify-content: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 700px;
    justify-content: left;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: ${grid.container.maxWidth};
  }
`;

const UnitSelector = ({
  unitSystem,
  selectedUnitSystem,
  onUnitSelectorChange,
  trackEvent,
  stepperEnabled,
}) => {
  const [modalSwitch, setModalSwitch] = useState(false);
  const [selectedUnitSystemState, setSelectedUnitSystemState] = useState(
    selectedUnitSystem
  );

  const radioGroup = Object.keys(unitSystem);

  const onChangeMock = (e) => {
    setSelectedUnitSystemState(e.target.value);
    setModalSwitch(!modalSwitch);
  };

  const onClose = (isConfirmed) => {
    if (isConfirmed === true) {
      onUnitSelectorChange(selectedUnitSystemState);
    }
    setModalSwitch(false);
  };

  return (
    <UnitSelectorWrapper
      className={`grid-maxWidthInner ${!stepperEnabled ? "no-padding" : ""}`}
      stepperEnabled={stepperEnabled}
      data-testid="unit-selector"
    >
      <GridSection className="grid-maxWidth">
        {radioGroup.map((unit) => {
          return (
            <DhlRadioButton
              key={unit}
              size={Sizes.SM}
              name="unitRadioGroup"
              dataId={`unit-selector-${unit}`}
              checked={unit === selectedUnitSystem}
              onDhlChange={onChangeMock}
              value={unit}
              dataTestId={`unit-selector-${unit}`}
            >
              {`${unitSystem[unit].weight}/${unitSystem[unit].length}`}
            </DhlRadioButton>
          );
        })}
      </GridSection>
      {modalSwitch && (
        <ModalUnitSwitchInfo
          isOpen={modalSwitch}
          unitSystem={unitSystem}
          newUnitValue={selectedUnitSystemState}
          onClose={onClose}
          trackEvent={trackEvent}
        />
      )}
    </UnitSelectorWrapper>
  );
};

UnitSelector.propTypes = {
  unitSystem: PropTypes.object.isRequired,
  selectedUnitSystem: PropTypes.string.isRequired,
  onUnitSelectorChange: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  stepperEnabled: PropTypes.bool,
};

export default UnitSelector;
